import { render, staticRenderFns } from "./addCompanionsMobile.vue?vue&type=template&id=086ef276&scoped=true"
import script from "./addCompanionsMobile.vue?vue&type=script&lang=js"
export * from "./addCompanionsMobile.vue?vue&type=script&lang=js"
import style0 from "./addCompanionsMobile.vue?vue&type=style&index=0&id=086ef276&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086ef276",
  null
  
)

export default component.exports